import { AxiosRead } from "@/repositories/clients/AxiosReadClient";
import { AxiosLandingClient } from '@/repositories/clients/AxiosLandingClient'

const resource = 'store/products';
const sampad = `${resource}/sampad`
const randomCourse = `${resource}/random`
const randomVideos = `${resource}/random_videos`
const liveClasses = `index.php`

export default {

    /**
     *  get products
     *  ------------------------
     *  Api address| /api/v1/site/store/products
     *  ------------------------
     *  Method| GET
     *  ------------------------
     *  @Description| get products
     *  ------------------------
     *  @param queryParams {Object} none-required
     *  ------------------------
     *  @return  type {Promise}
     *  ------------------------
     **/
    get(queryParams = null){
        return AxiosRead.get(`${resource}`, {
            params: {
                ...queryParams
            }
        });
    },
    /**
     *  get sampad products
     *  ------------------------
     *  Api address| v1/api/site/store/products/sampad
     *  ------------------------
     *  Method| GET
     *  ------------------------
     *  @Description| get sampad products
     *  ------------------------
     *  @param queryParams {Object} none-required
     *  ------------------------
     *  @return  type {Promise}
     *  ------------------------
     **/
    getSampad(queryParams = null){
        return AxiosRead.get(`${sampad}`,{
            params:{
                ...queryParams
            }
        })
    },

    getRandom(id, queryParams = null){
        return AxiosRead.get(`${randomCourse}?grades[]=${id}`, {
            params:{
                ...queryParams
            }
        })
    },
    getRandomVideos(id,queryParams = null){
        return AxiosRead.get(`${randomVideos}?grades[]=${id}`, {
            params:{
                ...queryParams
            }
        })

    },

    getLiveVideos(queryParams = null){
        return AxiosLandingClient.get(`${liveClasses}`, {
            params:{
                ...queryParams
            }
        })
    },

    /**
     *  get one product by id
     *  ------------------------
     *  Api address| /api/v1/site/products/:id
     *  ------------------------
     *  Method| GET
     *  ------------------------
     *  @Description| get one product by id
     *  ------------------------
     *  @param id {String} required | product id
     *  @param queryParams {Object} none-required
     *   -----------------------
     *  @return  type {Promise}
     *  ------------------------
     **/
    getOne(id,queryParams = null){
        return AxiosRead.get(`${resource}/new/${id}`, {
            params: {
                ...queryParams
            }
        });
    },

    /**
     *  get one product's comments by id
     *  ------------------------
     *  Api address| /api/v1/site/products/:id/comments
     *  ------------------------
     *  Method| GET
     *  ------------------------
     *  @Description| get one product's comments by id
     *  ------------------------
     *  @param id {String} required | product id
     *  @param queryParams {Object} none-required
     *   -----------------------
     *  @return  type {Promise}
     *  ------------------------
     **/
    comments(id,queryParams = null){
        return AxiosRead.get(`${resource}/${id}/comments`, {
            params: {
                ...queryParams
            }
        });
    },


    /**
     *  get product's filters
     *  ------------------------
     *  Api address| /api/v1/site/store/products/filters
     *  ------------------------
     *  Method| GET
     *  ------------------------
     *  @Description| get product's filters
     *  ------------------------
     *  @param queryParams {Object} none-required
     *   -----------------------
     *  @return  type {Promise}
     *  ------------------------
     **/
    filters(queryParams = null){
        return AxiosRead.get(`${resource}/filters`, {
            params: {
                ...queryParams
            }
        });
    }



}
